var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.492,
    height: 22,
    viewBox: "0 0 24.492 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-531.013 -295.758)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M555.19,304.67a6.769,6.769,0,0,0-3.631-.979,7.04,7.04,0,0,0-3.261.761,7.032,7.032,0,0,0-3.26-.761,6.775,6.775,0,0,0-3.632.979.68.68,0,0,0-.314.575v8.261a.685.685,0,0,0,1.055.576,5.87,5.87,0,0,1,5.781,0,.686.686,0,0,0,.741,0,5.87,5.87,0,0,1,5.781,0,.683.683,0,0,0,.37.109.693.693,0,0,0,.328-.084.684.684,0,0,0,.357-.6v-8.261A.681.681,0,0,0,555.19,304.67Zm-1.055.969V312.4a7.689,7.689,0,0,0-5.152,0v-6.762A6.187,6.187,0,0,1,554.135,305.639Zm-6.521,0V312.4a7.569,7.569,0,0,0-5.153,0v-6.764A6.19,6.19,0,0,1,547.614,305.643Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M548.888,299.186a10.74,10.74,0,0,1-8.076-3.2.71.71,0,0,0-1.036,0,10.738,10.738,0,0,1-8.076,3.2.688.688,0,0,0-.687.688,21.51,21.51,0,0,0,8.888,17.76.686.686,0,0,0,.787,0,19.738,19.738,0,0,0,3.758-3.443h-1.858a18.1,18.1,0,0,1-2.294,2.032,20.12,20.12,0,0,1-7.9-15.678,12.25,12.25,0,0,0,7.9-3.114,12.25,12.25,0,0,0,7.9,3.114,21.767,21.767,0,0,1-.252,2.681h1.387a23.367,23.367,0,0,0,.25-3.352A.687.687,0,0,0,548.888,299.186Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferential);
export default __webpack_public_path__ + "static/media/referential.43e06f4a8d8ae773171c6416c5f2604b.svg";
export { ForwardRef as ReactComponent };